import React from 'react';
import styles from './Award.module.scss';
import PropTypes from 'prop-types';
import TimedButton from '../TimedButton/TimedButton';
import Heading from '../Heading/Heading';
import classNames from 'classnames';

const Award = ({ close, emoji, open }) => {
  return (
    <section className={classNames(styles.award, { [styles.open]: open })}>
      <div className={styles.content}>
        <Heading className={styles.heading}>You unlocked a new emoji!</Heading>
        <div className={styles.emoji}>{emoji}</div>
        {open && (
          <TimedButton onClick={close} time={10000}>
            Back to game
          </TimedButton>
        )}
      </div>
    </section>
  );
};

Award.propTypes = {
  close: PropTypes.func,
  emoji: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  open: PropTypes.bool,
};

Award.defaultProps = {
  close: null,
  list: null,
  open: false,
};

export default Award;
